// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import moment from "moment-timezone";
import { canonicalZone, zoneOffsetMinutes, zonedToInstant } from "@sequentech/ui-core";
export var EExportRange;
(function (EExportRange) {
    /** Nothing chosen, or a start before the end. */
    EExportRange["VALID"] = "VALID";
    /** The end is not after the start. */
    EExportRange["END_NOT_AFTER_START"] = "END_NOT_AFTER_START";
    EExportRange["INVALID_BOUND"] = "INVALID_BOUND";
})(EExportRange || (EExportRange = {}));
var WALL_CLOCK = ["YYYY-MM-DDTHH:mm", "YYYY-MM-DDTHH:mm:ss"];
/** A `datetime-local` value, a wall-clock time of the event's zone, as that instant. */
function instant(value, timeZone) {
    if (!value)
        return undefined;
    var parsed = moment.utc(value, WALL_CLOCK, true);
    if (!parsed.isValid())
        return undefined;
    try {
        var resolved = zonedToInstant(value.slice(0, 16), timeZone);
        if (resolved.kind === "gap")
            return undefined;
        // Resolve with the same timezone service as every other admin input;
        // keep the seconds accepted by this export's existing wire contract.
        var instant_1 = moment
            .utc(resolved.instant)
            .add(value.length > 16 ? Number(value.slice(17, 19)) : 0, "seconds");
        return instant_1.utcOffset(zoneOffsetMinutes(timeZone, instant_1.toDate()));
    }
    catch (_a) {
        return undefined;
    }
}
/**
 * `datetime-local` values are wall-clock times with no zone. They are read in
 * the event's time zone, as the dialog says, and sent as RFC 3339 instants with
 * that zone's offset at that moment, which the export requires: across a change
 * of clocks the two bounds can have different offsets.
 */
export function exportBound(value, timeZone) {
    var parsed = instant(value, timeZone);
    if (!parsed)
        return undefined;
    return parsed.utcOffset() === 0
        ? parsed.utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
        : parsed.format();
}
export function exportRange(from, to, timeZone) {
    var start = instant(from, timeZone);
    var end = instant(to, timeZone);
    try {
        canonicalZone(timeZone);
    }
    catch (_a) {
        return EExportRange.INVALID_BOUND;
    }
    if ((from && !start) || (to && !end)) {
        return EExportRange.INVALID_BOUND;
    }
    if (!start || !end)
        return EExportRange.VALID;
    return end.isAfter(start) ? EExportRange.VALID : EExportRange.END_NOT_AFTER_START;
}
